module.exports = __webpack_public_path__ + "static/media/service9.12194a00.jpg";